const TimerIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_535_5060)">
      <path
        d="M5.31834 4.97325C6.64646 3.90914 8.29817 3.33054 10 3.33325C11.7708 3.33325 13.3983 3.94659 14.6817 4.97325L15.8925 3.76242L17.0708 4.94075L15.86 6.15159C16.7414 7.25504 17.2934 8.58494 17.4523 9.98824C17.6113 11.3915 17.3708 12.8112 16.7586 14.0839C16.1463 15.3565 15.1872 16.4305 13.9915 17.1821C12.7959 17.9337 11.4123 18.3324 10 18.3324C8.58773 18.3324 7.20415 17.9337 6.0085 17.1821C4.81284 16.4305 3.85369 15.3565 3.24144 14.0839C2.62918 12.8112 2.3887 11.3915 2.54767 9.98824C2.70663 8.58494 3.25858 7.25504 4.14 6.15159L2.92917 4.94159L4.1075 3.76325L5.31834 4.97408V4.97325ZM10.8333 9.99992V6.24575L6.66667 11.6666H9.16667V15.4166L13.3333 9.99992H10.8333ZM6.66667 0.833252H13.3333V2.49992H6.66667V0.833252Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_535_5060">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default TimerIcon;
